import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
//import ApkButton from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './ASoftCard.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
        // bizInfo: soft_.bizInfo
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.soft_card}>
      <Link
        className={styles.soft_card_app_logo}
        to={{
          pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
            '{}'}`,
        }}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        <div className={styles.soft_card_logo} />
      </Link>
      <div className={styles.soft_card_box}>
        <Link
          to={{
            pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
              '{}'}`,
          }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div className={styles.soft_card_title} title={soft.softName}>
            {soft.softName}
          </div>
          <div
            className={styles.soft_card_desc}
            title={soft.cardShowDesc ? soft.introduction : `${soft.downloadCount}安装`}
          >
            {soft.cardShowDesc ? soft.introduction : `${soft.downloadCount}安装`}
          </div>
        </Link>
        <div className={styles.soft_card_opt}>
          <ApkButton soft={soft} info={{}} logInfo={logInfo} />
        </div>
      </div>
    </div>
  );
});
